// extracted by mini-css-extract-plugin
export default {"signing":"HeaderNavbar_signing__QKN1l","navGroup":"HeaderNavbar_navGroup__A4fmd"};